import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import { useRouter } from 'expo-router'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { goBackOrHome } from '../../lib/goBack'
import { COMPACT_HEADER_STYLE } from '../../lib/gameChrome'

/**
 * Back + olive icon + title row for the screens reached from the home header
 * icons (Maps, Synthetic Command, Hall of Fame, Settings). The icon matches the
 * home button that opens the screen.
 */
export function ScreenHeader({
  title,
  icon,
  onBack,
  backLabel = 'Go back',
}: {
  title: string
  icon: React.ComponentProps<typeof MaterialCommunityIcons>['name']
  /** Defaults to going back, or home when there is no history. */
  onBack?: () => void
  backLabel?: string
}) {
  const router = useRouter()
  return (
    <View className="flex-row items-center px-4 border-b border-olive" style={COMPACT_HEADER_STYLE}>
      <TouchableOpacity
        onPress={onBack ?? (() => goBackOrHome(router))}
        accessibilityLabel={backLabel}
        accessibilityRole="button"
        className="mr-3 p-1"
      >
        <Text className="font-typed text-blood text-base">← Back</Text>
      </TouchableOpacity>
      <MaterialCommunityIcons name={icon} size={22} color="#8aa14a" style={{ marginRight: 8 }} />
      <View className="flex-1">
        <Text className="font-stencil text-ink text-lg uppercase" numberOfLines={1}>{title}</Text>
      </View>
    </View>
  )
}
